import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { NgIcon } from '@ng-icons/core';
import { injectViewportBreakpoints } from '@quipex/core/utils';
import { QpxButton, QpxIcon, QpxTooltip } from '../../../directives';
import type { FilePreviewAction } from '../models';

@Component({
    selector: 'qpx-preview-action-buttons',
    imports: [
        MatMenuModule,
        MatButtonModule,
        QpxTooltip,
        NgIcon,
        QpxButton,
        QpxIcon,
    ],
    templateUrl: './preview-action-buttons.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'contents',
    },
})
export class PreviewActionButtons {
    protected readonly mobile = injectViewportBreakpoints().isPhone;

    private readonly overflowTrigger = viewChild<
        unknown,
        ElementRef<HTMLButtonElement>
    >('moreActions', { read: ElementRef });

    //#region Inputs
    public readonly actions = input<readonly FilePreviewAction[]>([]);
    //#endregion
    protected selectOverflowAction(
        action: FilePreviewAction,
        event: MouseEvent
    ): void {
        action.onSelect({
            origin: this.overflowTrigger()?.nativeElement ?? null,
            event,
        });
    }
}
